module.exports = __webpack_public_path__ + "static/assets/db9e6014ed7c47cb83d7131b274fc06e.svg";